import { createSlice } from '@reduxjs/toolkit';
import * as penjualanService from '../services/penjualanService';
import config from '../config';

const initialState = {
    loading : false,
    hasErrors : false,
    penjualans : [],
    penjualan : {},
    list_page : [],
    pesan : ''
}

const penjualanStoreSlice = createSlice({
    name : 'penjualanStore',
    initialState,
    reducers : {
        getData : (state) => { state.loading = true},
        getDataSuccess : (state, action) => {
            state.loading = false;
            state.hasErrors = false;
            state.penjualans = action.payload.data;
            state.list_page = action.payload.list_page;
        },
        getDataFailure : (state) => { state.loading = false; state.hasErrors = true},
        setDetail : (state, action) => {
            state.loading = false;
            state.hasErrros = false;
            state.penjualan = action.payload;
        },
        deleteData : (state, action) => {            
            state.loading = false;
            state.hasErrors = false;
            state.penjualans = state.penjualans.filter(item => item.id !== action.payload);
        },
        setPesan : (state, action) => {
            state.pesan = action.payload;
        }
    }
})

export const { getData, getDataSuccess, getDataFailure, setDetail, deleteData, setPesan } = penjualanStoreSlice.actions;

export const penjualanSelector = (state) => state.penjualans;

export default penjualanStoreSlice.reducer;


export function fetchPenjualan(q='', limit=config.itemPerPage, page=1){
    return async(dispatch) => {
        dispatch(getData());
        try{
            const response = await penjualanService.getPenjualan(q, limit, page);
            const data = await response;            
            if(data.sukses === 'yes'){
                dispatch(getDataSuccess(data))
            }else{
                dispatch(getDataFailure());
            }
        }catch(error){
            dispatch(getDataFailure());
        }
    }
}

